// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { infoCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-info-circle': IconInfoCircle;
    }
}

/**
 * The icon component for the 'infoCircle' icon
 */
export class IconInfoCircle extends Icon {
    public constructor() {
        super(infoCircle16X16);
    }
}

registerIcon('icon-info-circle', IconInfoCircle);
export const iconInfoCircleTag = 'nimble-icon-info-circle';
